import { render, staticRenderFns } from "./social-proof.vue?vue&type=template&id=edeb3326&scoped=true&"
import script from "./social-proof.vue?vue&type=script&lang=js&"
export * from "./social-proof.vue?vue&type=script&lang=js&"
import style0 from "./social-proof.vue?vue&type=style&index=0&id=edeb3326&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edeb3326",
  null
  
)

export default component.exports